import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/Users/evusla/.nvm/versions/node/v20.11.0/lib/node_modules/workbox-cli/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "build/assets/app-Bl1XHUXX.js",
    "revision": "33c8837e41f7bf9b16c2cf7102f6f875"
  },
  {
    "url": "build/assets/AppBackdrop-Bk3WIJU_.js",
    "revision": "f6ca592db05e7a8459ebba184aa687dc"
  },
  {
    "url": "build/assets/AppDataGrid-BGYfNSIB.js",
    "revision": "5fe04f483e40afe66c4b1a068468ef23"
  },
  {
    "url": "build/assets/AppLayout-DlKHAfSm.js",
    "revision": "a7ac9ffc6229f1791d4345e23561e401"
  },
  {
    "url": "build/assets/AuthLayout-B8Zx_k8g.js",
    "revision": "e900aa99bf1c7e2a7be3481af2dc04ca"
  },
  {
    "url": "build/assets/Badge-BOfjZSkr.js",
    "revision": "372367e8dff7cc7b1f9cb9667f4dc262"
  },
  {
    "url": "build/assets/Breadcrumbs-Br6jLEHd.js",
    "revision": "bf72140f04a902d7d29623b0e8c93154"
  },
  {
    "url": "build/assets/DialogContent-BAzeQJVv.js",
    "revision": "0f21daa9383deb7747885504445e9ad1"
  },
  {
    "url": "build/assets/index-CKPMpEja.js",
    "revision": "d874f524d77fd160aab7978f94434468"
  },
  {
    "url": "build/assets/index-cM0r0yqi.js",
    "revision": "3a3448b8cd3f0039f65215ac2654da86"
  },
  {
    "url": "build/assets/index-D1fQa4zb.js",
    "revision": "a4c6e827ad7aa0423ddfbe3533039811"
  },
  {
    "url": "build/assets/index-hb2CJUhy.js",
    "revision": "fb81da6df9ba31cb505b3132d60a91bf"
  },
  {
    "url": "build/assets/ListItem-BaDqU-Wk.js",
    "revision": "4d9882ba7ddfa27c7611553b2991199e"
  },
  {
    "url": "build/assets/listItemButtonClasses-Bqt3DLBE.js",
    "revision": "823f6937354b688b0ca8cd93a27f416a"
  },
  {
    "url": "build/assets/ListItemText-CGcH3Xei.js",
    "revision": "bb40efff1a3a529971339ac7cb9ac624"
  },
  {
    "url": "build/assets/LocalizationProvider-DVrUgqWM.js",
    "revision": "ae830b2f9eac0c8a84f9eeaaec9eb1ec"
  },
  {
    "url": "build/assets/material-ui-confirm.esm-D9X47YKJ.js",
    "revision": "17873807c44c1d7c746798a2bdb28b94"
  },
  {
    "url": "build/assets/MuiIcon-v6Xz-FXr.js",
    "revision": "070609ae8431186a6ba60c9864de566c"
  },
  {
    "url": "build/assets/Notification-CUWMoDY3.js",
    "revision": "50eb0c76e3156ec94f906a90dda990e5"
  },
  {
    "url": "build/assets/Notifications-FCF3VLBS.js",
    "revision": "c3bcd939ba5d12ceec612b1b814556d3"
  },
  {
    "url": "build/assets/Popper-DMOFLRtE.js",
    "revision": "d8d5ad4a3cc6dab16935e8cc56bee2a5"
  },
  {
    "url": "build/assets/PublicLayout-DV8zN9dM.js",
    "revision": "03a0de376b2982baaaa61fb18ec7eb47"
  },
  {
    "url": "build/assets/Scheduler-BaK7himy.js",
    "revision": "3260369b01d95a617888835447f2e6aa"
  },
  {
    "url": "build/assets/str-DeGccPEs.js",
    "revision": "10e5aa077f8943f89ddb0584954de2b5"
  },
  {
    "url": "build/assets/ThemeProvider-Bbq1F-cO.js",
    "revision": "a5eb602578c301bb881b25c1bdfc30c2"
  },
  {
    "url": "build/assets/Toolbar-CAekImCw.js",
    "revision": "9c643b1d37fbb29c9b00b96acbe2a258"
  },
  {
    "url": "build/assets/UpdateOrCreate-BdnbGaVr.css",
    "revision": "b056e381b6bf27af01c2b8e6e3b4e315"
  },
  {
    "url": "build/assets/UpdateOrCreate-rNweR1Zh.js",
    "revision": "94cec3a5a77ed003ab0d9d97317b5e30"
  },
  {
    "url": "build/assets/useMediaQuery-B8lTWi1n.js",
    "revision": "b9a1616ce111a5f64c54cdd6c10f05c4"
  },
  {
    "url": "build/manifest.json",
    "revision": "bf2fb47aa5ff116ccd18a806a166c3d0"
  },
  {
    "url": "favicon.ico",
    "revision": "e4faa6ad67506f566ef45156dc960693"
  },
  {
    "url": "images/fondo.png",
    "revision": "51c74ddf356a729f931eb10d77ceeecd"
  },
  {
    "url": "images/logo-h.png",
    "revision": "34fbd37c7ca1ba2d5a07b4c16166f303"
  },
  {
    "url": "images/logo-individual.png",
    "revision": "db2eeacb74287a82257bcfea64b486d7"
  },
  {
    "url": "images/logo.png",
    "revision": "8d05b38cd330a40651e1b8e80259bcbf"
  },
  {
    "url": "images/puntopadel-1.jpg",
    "revision": "3b30b1438f0a9aeae3cb3e40b61e1a69"
  },
  {
    "url": "images/puntopadel-2.jpg",
    "revision": "e99088ea93b4c165dc9fe2d57145919e"
  },
  {
    "url": "images/puntopadel-3.jpg",
    "revision": "72e06bd6f513461ea56cccde4d4b1696"
  },
  {
    "url": "images/pwa/android-chrome-192x192.png",
    "revision": "db212ba0749adab9a0f2ead625739ff5"
  },
  {
    "url": "images/pwa/android-chrome-512x512.png",
    "revision": "255ac2bc9a1a85ee3edb72d1ecde435c"
  },
  {
    "url": "images/pwa/apple-touch-icon.png",
    "revision": "242ba05d5d4b832cabf546d8d52396da"
  },
  {
    "url": "images/pwa/favicon-16x16.png",
    "revision": "24efc1db8b3d217e4661469dca8db69e"
  },
  {
    "url": "images/pwa/favicon-32x32.png",
    "revision": "0c1827a628bfdd38f8018a4e5b91c92c"
  },
  {
    "url": "images/pwa/favicon.ico",
    "revision": "e4faa6ad67506f566ef45156dc960693"
  },
  {
    "url": "index.php",
    "revision": "3b58bff18126a61c142cc576457c82a6"
  },
  {
    "url": "manifest.json",
    "revision": "d9f4caa072802ab8ae660f5bd4b2cbb3"
  },
  {
    "url": "robots.txt",
    "revision": "b6216d61c03e6ce0c9aea6ca7808f7ca"
  },
  {
    "url": "vendor/telescope/app-dark.css",
    "revision": "1ea407db56c5163ae29311f1f38eb7b9"
  },
  {
    "url": "vendor/telescope/app.css",
    "revision": "de4c978567bfd90b38d186937dee5ccf"
  },
  {
    "url": "vendor/telescope/app.js",
    "revision": "7049e92a398e816f8cd53a915eaea592"
  },
  {
    "url": "vendor/telescope/favicon.ico",
    "revision": "a903f931a3fcbcb88c8c8ab8d5b189b8"
  },
  {
    "url": "vendor/telescope/mix-manifest.json",
    "revision": "6edd1bf0a3bf844e0e4b4c614e1b7c31"
  }
], {
  "ignoreURLParametersMatching": [/^utm_/, /^fbclid$/]
});








